import { RouteObject } from 'react-router-dom';

import { AdminLayout } from '@/layouts/AdminLayout';
import { WelcomeLayout } from '@/layouts/WelcomeLayout';
import { RootLayout } from '@/layouts/RootLayout';

import { NotFound } from '@/pages/others/NotFound';
import CompanyInformation from '@/pages/company-profile/CompanyInformation';
import CompanyData from '@/pages/company-profile/CompanyData';
import Purpose from '@/pages/company-profile/Purpose';
import Positioning from '@/pages/company-profile/Positioning';
import Vision from '@/pages/company-profile/Vision';
import Mission from '@/pages/company-profile/Mission';
import Culture from '@/pages/company-profile/Culture';
import BusinessGoal from '@/pages/company-profile/BusinessGoal';
import KeyActivities from '@/pages/company-profile/KeyActivities';
import OrganizationStructure from '@/pages/company-profile/OrganizationStructure';
import JobDescription from '@/pages/company-profile/JobDescription';
import JobDescriptionDetail from '@/pages/company-profile/JobDescriptionDetail';
import Report from '@/pages/company-profile/Report';
import ReportDetail from '@/pages/company-profile/ReportDetail';
import KPI from '@/pages/company-profile/KPI';
import MyKpi from '@/pages/company-profile/MyKpi';
import MyKpiDetail from '@/pages/company-profile/my-kpi/MyKpiDetail';
import ApprovalKpi from '@/pages/company-profile/ApprovalKpi';
import ApprovalKpiDetail from '@/pages/company-profile/approval-kpi/ApprovalKpiDetail';
import KpiTemplate from '@/pages/company-profile/KpiTemplate';
import KpiTemplateForm from '@/pages/company-profile/kpi-template/KpiTemplateForm';
import Reward from '@/pages/company-profile/Reward';
import Punishment from '@/pages/company-profile/Punishment';
import RewardPunishment from '@/pages/company-profile/RewardPunishment';
import SOP from '@/pages/company-profile/SOP';
import SOPDetail from '@/pages/company-profile/sop/SOPDetail';
import Train from '@/pages/company-profile/Train';
import Checklist from '@/pages/company-profile/Checklist';
import Discussion from '@/pages/company-profile/Discussion';
import { NotificationPage } from '@/pages/notification/NotificationPage';
import { ProtectedRoute } from '@/components/shared/gate/ProtectedRoute';
import { CompanyDataGuard } from '@/components/shared/gate/CompanyDataGuard';
import { CompanyProfileCompleteGuard } from '@/components/shared/gate/CompanyProfileCompleteGuard';
import { Login } from '@/pages/Login/login';
import Callback from '@/pages/Login/callback';
import { VerifyEmail } from '@/pages/Login/VerifyEmail';
import { ProtectedGlobalRoute } from '@/components/shared/gate/ProtectedGlobalRoute';
import { EmployeeRoleGuard } from '@/components/shared/gate/EmployeeRoleGuard';
import { HasTeamGuard } from '@/components/shared/gate/HasTeamGuard';
import { AdminOnlyGuard } from '@/components/shared/gate/AdminOnlyGuard';
import Workspaces from '@/pages/workspaces/Workspaces';
import ExportAllWorkspaces from '@/pages/admin/ExportAllWorkspaces';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import DownloadDocument from '@/pages/company-profile/DownloadDocument';
import PanduanImplementasi from '@/pages/company-profile/PanduanImplementasi';
import Dashboard from '@/components/pages/dashboard/Dashboard';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'callback',
        element: <Callback />,
      },
      {
        path: 'verify-email',
        element: <VerifyEmail />,
      },

      {
        path: '/',
        element: <ProtectedGlobalRoute layout={WelcomeLayout} />,
        children: [
          { index: true, element: <></> },
          {
            path: '/workspaces',
            element: <Workspaces />,
          },
          {
            path: '/export-all-workspaces',
            element: <ExportAllWorkspaces />,
          },
        ],
      },
      {
        path: ':tenant_id',
        element: <ProtectedRoute layout={AdminLayout} />,
        children: [
          {
            index: true,
            element: <Dashboard />,
            handle: { breadcrumb: 'Dashboard', category: 'Dashboard' },
          },
          {
            path: 'dashboard',
            element: <Dashboard />,
            handle: { breadcrumb: 'Dashboard', category: 'Dashboard' },
          },

          {
            path: 'company-profile',
            element: (
              <CompanyDataGuard>
                <CompanyInformation />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Profile', category: 'Pra AOS' },
          },
          {
            path: 'data-perusahaan',
            element: (
              <EmployeeRoleGuard>
                <CompanyData />
              </EmployeeRoleGuard>
            ),
            handle: { breadcrumb: 'Data Perusahaan', category: 'Pra AOS' },
          },
          {
            path: 'export-all-workspaces',
            element: (
              <EmployeeRoleGuard>
                <ExportAllWorkspaces />
              </EmployeeRoleGuard>
            ),
            handle: { breadcrumb: 'Ekspor Semua Workspace', category: 'Admin' },
          },
          {
            path: 'checklist',
            element: (
              <EmployeeRoleGuard>
                <CompanyProfileCompleteGuard>
                  <Checklist />
                </CompanyProfileCompleteGuard>
              </EmployeeRoleGuard>
            ),
            handle: { breadcrumb: 'Implementasi AOS', category: 'AOS CHECKLIST' },
          },
          {
            path: 'discussions',
            element: (
              <EmployeeRoleGuard>
                <Discussion />
              </EmployeeRoleGuard>
            ),
            handle: { breadcrumb: 'Diskusi', category: 'Pra AOS' },
          },
          {
            path: 'purpose',
            element: (
              <CompanyDataGuard>
                <Purpose />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: ' Langkah 0: Purpose (Tujuan Fundamental)', category: 'Perancangan AOS' },
          },
          {
            path: 'positioning',
            element: (
              <CompanyDataGuard>
                <Positioning />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Langkah 0: Brand Positioning (Posisi Pasar)', category: 'Perancangan AOS' },
          },
          {
            path: 'vision',
            element: (
              <CompanyDataGuard>
                <Vision />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Langkah 1: Business Vision (Visi Perusahaan)', category: 'Perancangan AOS' },
          },
          {
            path: 'mission',
            element: (
              <CompanyDataGuard>
                <Mission />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Langkah 2: Business Mission (Peta Jalan Misi)', category: 'Perancangan AOS' },
          },
          {
            path: 'culture',
            element: (
              <CompanyDataGuard>
                <Culture />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Langkah 3: Core Values & Culture (Budaya Kerja)', category: 'Perancangan AOS' },
          },
          {
            path: 'business-goal',
            element: (
              <CompanyDataGuard>
                <BusinessGoal />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Langkah 4: Business Goal (Sasaran Keuangan)', category: 'Perancangan AOS' },
          },
          {
            path: 'organization-structure',
            element: (
              <CompanyDataGuard>
                <OrganizationStructure />
              </CompanyDataGuard>
            ),
            handle: {
              breadcrumb: 'Langkah 5: Organization Structure (Struktur Fungsional)',
              category: 'Perancangan AOS',
            },
          },
          {
            path: 'key-activities',
            element: (
              <CompanyDataGuard>
                <KeyActivities />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Langkah 6: Key Activities (Aktivitas Inti)', category: 'Perancangan AOS' },
          },
          {
            path: 'job-description',
            element: (
              <CompanyDataGuard>
                <JobDescription />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Langkah 7: Job Description (Deskripsi Jabatan)', category: 'Perancangan AOS' },
          },
          {
            path: 'job-description/peran/:nodeId',
            element: (
              <CompanyDataGuard>
                <JobDescriptionDetail />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Detail Peran', category: 'Perancangan AOS' },
          },
          {
            path: 'report',
            element: (
              <CompanyDataGuard>
                <Report />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Langkah 8: Reporting System (Sistem Pelaporan)', category: 'Perancangan AOS' },
          },
          {
            path: 'report/peran/:nodeId',
            element: (
              <CompanyDataGuard>
                <ReportDetail />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Detail Report Jabatan', category: 'Perancangan AOS' },
          },
          {
            path: 'kpi',
            element: (
              <CompanyDataGuard>
                <KPI />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Langkah 9: KPI Setup (Indikator Kinerja Utama)', category: 'Perancangan AOS' },
          },
          {
            path: 'kpi-saya',
            element: (
              <CompanyDataGuard>
                <MyKpi />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'KPI Saya', category: 'INPUT KPI' },
          },
          {
            path: 'kpi-saya/:id',
            element: (
              <CompanyDataGuard>
                <MyKpiDetail />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Detail KPI Saya', category: 'INPUT KPI' },
          },
          {
            path: 'kpi-approval',
            element: (
              <CompanyDataGuard>
                <HasTeamGuard>
                  <ApprovalKpi />
                </HasTeamGuard>
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Approval KPI', category: 'INPUT KPI' },
          },
          {
            path: 'kpi-approval/:id',
            element: (
              <CompanyDataGuard>
                <HasTeamGuard>
                  <ApprovalKpiDetail />
                </HasTeamGuard>
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Detail Approval KPI', category: 'INPUT KPI' },
          },
          {
            path: 'kpi-pengguna',
            element: (
              <CompanyDataGuard>
                <AdminOnlyGuard>
                  <ApprovalKpi readOnly />
                </AdminOnlyGuard>
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'User KPI', category: 'INPUT KPI' },
          },
          {
            path: 'kpi-pengguna/:id',
            element: (
              <CompanyDataGuard>
                <AdminOnlyGuard>
                  <ApprovalKpiDetail readOnly />
                </AdminOnlyGuard>
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Detail User KPI', category: 'INPUT KPI' },
          },
          {
            path: 'kpi-template',
            element: (
              <CompanyDataGuard>
                <HasTeamGuard>
                  <KpiTemplate />
                </HasTeamGuard>
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Template KPI', category: 'INPUT KPI' },
          },
          {
            path: 'kpi-template/create',
            element: (
              <CompanyDataGuard>
                <HasTeamGuard>
                  <KpiTemplateForm />
                </HasTeamGuard>
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Buat Template', category: 'INPUT KPI' },
          },
          {
            path: 'kpi-template/:id/view',
            element: (
              <CompanyDataGuard>
                <HasTeamGuard>
                  <KpiTemplateForm />
                </HasTeamGuard>
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Detail Template', category: 'INPUT KPI' },
          },
          {
            path: 'kpi-template/:id/edit',
            element: (
              <CompanyDataGuard>
                <HasTeamGuard>
                  <KpiTemplateForm />
                </HasTeamGuard>
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Edit Template', category: 'INPUT KPI' },
          },
          {
            path: 'reward-punishment',
            element: (
              <CompanyDataGuard>
                <RewardPunishment />
              </CompanyDataGuard>
            ),
            handle: {
              breadcrumb: 'Langkah 10: Reward & Punishment (Penghargaan & Sanksi)',
              category: 'Perancangan AOS',
            },
          },
          {
            path: 'reward',
            element: (
              <CompanyDataGuard>
                <Reward />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Reward', category: 'Perancangan AOS' },
          },
          {
            path: 'punishment',
            element: (
              <CompanyDataGuard>
                <Punishment />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Punishment', category: 'Perancangan AOS' },
          },
          {
            path: 'sop',
            element: (
              <CompanyDataGuard>
                <SOP />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: ' Langkah 11: Standar Operasional Prosedur (SOP)', category: 'Perancangan AOS' },
          },
          {
            path: 'sop/:id',
            element: (
              <CompanyDataGuard>
                <SOPDetail />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Detail SOP', category: 'Perancangan AOS' },
          },
          {
            path: 'train',
            element: (
              <CompanyDataGuard>
                <Train />
              </CompanyDataGuard>
            ),
            handle: { breadcrumb: 'Langkah 12: Train The Trainer (Kaderisasi Staf)', category: 'Perancangan AOS' },
          },
          {
            path: 'download-document',
            element: (
              <CompanyDataGuard>
                <DownloadDocument />
              </CompanyDataGuard>
            ),
            handle: {
              breadcrumb: 'Download AOS Document',
              category: 'Perancangan AOS',
            },
          },
          {
            path: 'panduan-implementasi',
            element: (
              <CompanyDataGuard>
                <PanduanImplementasi />
              </CompanyDataGuard>
            ),
            handle: {
              breadcrumb: 'Panduan Implementasi',
              category: 'Implementasi AOS',
            },
          },
          {
            path: 'notifications',
            element: <NotificationPage />,
            handle: { breadcrumb: 'Notifikasi', category: 'Notifikasi' },
          },
          {
            path: '*',
            element: <NotFound />,
          },
        ],
      },
      {
        path: '*',
        element: <AdminLayout />,
        children: [{ path: '*', element: <NotFound /> }],
      },
    ],
  },
];
